import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import {
  getIsHotelOnly,
  getIsMobile,
  searchTypeSelector,
} from 'src/store/view/selectors';
import { i18n } from '@lt/localization';
import {
  getSimilarPackagesOffers,
  getSimilarPackagesHotelOffersCount,
  getSimilarPackageIsPopupOpened,
  getSimilarPackagesHasAdjustParams,
  getSimilarPackagesState,
} from '../../store/selectors/similar-packages';
import {
  SimilarPackages,
  SimilarPackagesFail,
  SimilarPackagesProgress,
} from './index';
import Popup from '../Popup';
import OperatorInfoContainer from '../OperatorInfo';
import { getIsLoggedUser } from '../../store/selectors/user';
import {
  similarPackagesPopupClosedAction,
  createPackageAction,
} from '../../store/actions/similar-packages';
import { SIMILAR_PACKAGES_STATE } from '../../store/constants/similar-packages';

const baseCls = 'similar-packages';

class SimilarPackagesContainer extends React.PureComponent {
  render() {
    const {
      similarOffers,
      hotelOffersCount,
      onClose,
      onClick,
      status,
      isPopupOpened,
      isAdmin,
      hasAdjustParams,
      isHotelOnly,
      searchType,
      isMobile,
    } = this.props;

    const isRedirect = status === SIMILAR_PACKAGES_STATE.REDIRECT;
    const showCloseIcon = hasAdjustParams && !isRedirect;

    return (
      <Popup
        open={isPopupOpened}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        showCloseIcon={showCloseIcon}
        onClose={onClose}
        classNames={{
          overlay: baseCls,
          modal: `${baseCls}__modal`,
          closeButton: `${baseCls}__close`,
        }}
      >
        {isAdmin && (
          <OperatorInfoContainer className={`${baseCls}__operator-info`} />
        )}

        {status === SIMILAR_PACKAGES_STATE.PERFORMING && (
          <SimilarPackagesProgress
            baseCls={baseCls}
            title={i18n.t('checkout.similarPackage.outdate.title', {
              context: isHotelOnly ? 'hotel' : 'package',
            })}
            message={i18n.t('checkout.similarPackage.outdate.message')}
          />
        )}

        {status === SIMILAR_PACKAGES_STATE.ALTERNATIVE && (
          <SimilarPackages
            onClick={onClick}
            baseCls={baseCls}
            similarOffers={similarOffers}
            hasAdjustParams={hasAdjustParams}
            hotelOffersCount={hotelOffersCount}
            isHotelOnly={isHotelOnly}
            searchType={searchType}
            isMobile={isMobile}
          />
        )}

        {status === SIMILAR_PACKAGES_STATE.NO_RESULTS && (
          <SimilarPackagesFail
            baseCls={baseCls}
            onClose={onClose}
            hasAdjustParams={hasAdjustParams}
            isHotelOnly={isHotelOnly}
          />
        )}

        {status === SIMILAR_PACKAGES_STATE.REDIRECT && (
          <SimilarPackagesProgress
            baseCls={baseCls}
            title={`${i18n.t('checkout.similarPackage.redirect.title')}!`}
            message={i18n.t('checkout.similarPackage.redirect.message', {
              context: isHotelOnly ? 'hotel' : 'package',
            })}
          />
        )}
      </Popup>
    );
  }
}

SimilarPackagesContainer.defaultProps = {
  onClose: null,
  similarOffers: [],
  isAdmin: false,
  hotelOffersCount: 0,
};

SimilarPackagesContainer.propTypes = {
  isAdmin: PropTypes.bool,
  similarOffers: PropTypes.arrayOf(PropTypes.shape({})),
  isPopupOpened: PropTypes.bool.isRequired,
  hasAdjustParams: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  hotelOffersCount: PropTypes.number,
};

const mapStateToProps = (state) => ({
  similarOffers: getSimilarPackagesOffers(state),
  hotelOffersCount: getSimilarPackagesHotelOffersCount(state),
  isPopupOpened: getSimilarPackageIsPopupOpened(state),
  isAdmin: getIsLoggedUser(state),
  hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
  status: getSimilarPackagesState(state),
  isHotelOnly: getIsHotelOnly(state),
  searchType: searchTypeSelector(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(similarPackagesPopupClosedAction()),
  onClick: (data) => dispatch(createPackageAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimilarPackagesContainer);
